import { render, staticRenderFns } from "./RecuperationPixelFact.vue?vue&type=template&id=0c3e48ed&scoped=true&"
import script from "./RecuperationPixelFact.vue?vue&type=script&lang=js&"
export * from "./RecuperationPixelFact.vue?vue&type=script&lang=js&"
import style0 from "./RecuperationPixelFact.vue?vue&type=style&index=0&id=0c3e48ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3e48ed",
  null
  
)

export default component.exports